import { useTheme } from 'next-themes';

import { CharacteristicsItem } from './CharacteristicsItem';

import styles from './index.module.scss';

export const DeviceCharacteristics = ({ data }) => {
  const theme = useTheme();
  return (
    <div
      className={styles.bottom}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      <h2>{data?.specification?.title}</h2>
      <div className={styles.characteristics}>
        {data?.specification?.boxes?.map((characteristic) => {
          return (
            <CharacteristicsItem
              key={characteristic?.id}
              icon={
                theme?.resolvedTheme === 'dark' &&
                characteristic?.dark_mode_icon
                  ? characteristic?.dark_mode_icon
                  : characteristic?.icon
              }
              title={characteristic?.title}
              values={characteristic?.lines}
            />
          );
        })}
        {data?.additional_specification?.boxes?.map((characteristic) => {
          return (
            <CharacteristicsItem
              key={characteristic?.id}
              icon={
                theme?.resolvedTheme === 'dark' &&
                characteristic?.dark_mode_icon
                  ? characteristic?.dark_mode_icon
                  : characteristic?.icon
              }
              title={characteristic?.title}
              values={characteristic?.lines}
            />
          );
        })}
      </div>
    </div>
  );
};
